export default {};
throw new Error(`Could not resolve "three-stdlib" imported by "@appletosolutions/reactbits". Is it installed?`)